import { createContext, use } from 'react';

import type { ResolvedTheme, ThemePreference } from './theme';

export interface ThemeContextValue {
    /** What the operator chose. `system` is the default. */
    preference: ThemePreference;
    /** What is actually painted right now. */
    resolved: ResolvedTheme;
    setPreference: (next: ThemePreference) => void;
}

/*
 * The context and its hook live apart from `ThemeProvider.tsx` so that file
 * exports a component and nothing else — Vite's fast refresh gives up on a
 * module that mixes the two, which would mean a full page reload on every edit
 * to the provider.
 */
export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme(): ThemeContextValue {
    const value = use(ThemeContext);
    if (!value) throw new Error('useTheme must be used inside <ThemeProvider>');
    return value;
}
